// You can write more code here

import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';

/* START OF COMPILED CODE */

export default class NoTypingNotification extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // noTypingExplanationContainer
    const noTypingExplanationContainer = scene.add.container(-60, 0);
    this.add(noTypingExplanationContainer);

    // nineslice_2
    const nineslice_2 = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      100,
      40,
      10,
      10,
      10,
      10,
    );
    nineslice_2.scaleX = 2;
    nineslice_2.scaleY = 2;
    nineslice_2.setOrigin(1, 0);
    noTypingExplanationContainer.add(nineslice_2);

    // bitmaptext_1
    const bitmaptext_1 = scene.add.bitmapText(
      -84,
      40,
      'Aronui',
      'Typing is not available for this minigame',
    );
    bitmaptext_1.setOrigin(0.5, 0.5);
    bitmaptext_1.tintTopLeft = 5387071;
    bitmaptext_1.tintTopRight = 5387071;
    bitmaptext_1.tintBottomLeft = 5387071;
    bitmaptext_1.tintBottomRight = 5387071;
    bitmaptext_1.text = 'Typing is not available for this minigame';
    bitmaptext_1.fontSize = -16;
    bitmaptext_1.maxWidth = 160;
    noTypingExplanationContainer.add(bitmaptext_1);

    // exclamationMark
    const exclamationMark = scene.add.image(-176, 40, 'hud-icons', 240);
    exclamationMark.scaleX = 2;
    exclamationMark.scaleY = 2;
    noTypingExplanationContainer.add(exclamationMark);

    // keyboardHoverButton
    const keyboardHoverButton = new HUDButton(
      scene,
      -40,
      16,
      'ui-keyboard-off-button',
    );
    this.add(keyboardHoverButton);

    this.noTypingExplanationContainer = noTypingExplanationContainer;
    this.keyboardHoverButton = keyboardHoverButton;

    /* START-USER-CTR-CODE */
    this.initialize();
    /* END-USER-CTR-CODE */
  }

  private noTypingExplanationContainer: Phaser.GameObjects.Container;
  private keyboardHoverButton: HUDButton;

  /* START-USER-CODE */

  initialize() {
    this.noTypingExplanationContainer.setVisible(false);
    this.keyboardHoverButton.on('pointerover', () => {
      this.noTypingExplanationContainer.setVisible(true);
    });
    this.keyboardHoverButton.on('pointerout', () => {
      this.noTypingExplanationContainer.setVisible(false);
    });
    this.keyboardHoverButton.setSubmissionCallback(() => {
      this.noTypingExplanationContainer.setVisible(
        !this.noTypingExplanationContainer.visible,
      );
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
